<template>
  <mobileLayout v-if="isMobile" />
  <Layout v-else />
</template>
<script>
// 引入layout总模板
import Layout from '@/layout'

//引入 移动端的layout总模板
import mobileLayout from '@/mobileLayout'

export default {
  components: {
    Layout,
    mobileLayout
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/tLayout/index.vue